<template>
  <div>
    <Pane>
      <template v-slot:extra>
        <Draft v-if="mode === 'add'" @select="onSelectDraft" />
      </template>
    </Pane>

    <a-modal
      :visible="draftVisible"
      title="保存草稿"
      @ok="saveDraft"
      @cancel="cancelDraft"
    >
      <div style="padding: 8px 0">
        <a-input placeholder="请输入草稿标题" v-model="draftTitle" />
      </div>
    </a-modal>

    <a-card class="container">
      <div class="section-title">基本信息</div>
      <a-form-model
        ref="formRef"
        :model="form"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-row>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="标题" prop="title">
              <a-input v-model="form.title" placeholder="请输入标题" :max-length="100" />
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="优先级">
              <a-radio-group v-model="form.priority">
                <a-radio value="common">普通</a-radio>
                <a-radio value="urgent">紧急</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item label="工单类型" prop="workType" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
          <div class="type-cards">
            <div
              v-for="item in workTypeList"
              :key="item"
              class="type-card"
              :class="{ active: form.workType === item }"
              @click="onWorkTypeChange(item)"
            >
              <a-icon :type="getWorkTypeIcon(item)" class="type-icon" />
              <div class="type-name">{{ item }}</div>
              <div v-if="getWorkTypeDesc(item)" class="type-desc">{{ getWorkTypeDesc(item) }}</div>
            </div>
          </div>
        </a-form-model-item>

        <a-row>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="涉及模块" prop="workModule">
              <a-select
                v-model="form.workModule"
                placeholder="请选择涉及模块"
                @change="onWorkModuleChange"
                allowClear
              >
                <a-select-option v-for="item in workModuleList" :key="item" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="申请分类" prop="applyCategory">
              <a-select
                v-model="form.applyCategory"
                placeholder="请选择申请分类"
                show-search
                option-filter-prop="children"
                @change="onApplyCategoryChange"
                allowClear
              >
                <a-select-option v-for="item in applyCategoryList" :key="item" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item label="具体描述" prop="description" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
          <a-textarea
            v-model="form.description"
            placeholder="请输入具体描述"
            :auto-size="{ minRows: 5, maxRows: 10 }"
            :max-length="2000"
          />
        </a-form-model-item>

        <a-form-model-item label="申请附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
          <!-- 使用项目通用Uploader（自渲染列表+删除按钮），a-upload受控模式内置列表删除不可靠 -->
          <Uploader :list="fileList" :multiple="true" @change="onFilesChange" />
        </a-form-model-item>
      </a-form-model>

      <div class="section-title">申请人信息</div>
      <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }" :colon="true">
        <a-row>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="申请人">
              <a-input :value="applicantName" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="所属部门">
              <a-input :value="deptName" :disabled="true" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <div class="section-title">处理人信息</div>
      <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }" :colon="true">
        <a-row>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="处理部门">
              <a-input :value="handler.deptName" :disabled="true" placeholder="按工单类型自动匹配" />
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :sm="24">
            <a-form-model-item label="工单处理人">
              <!-- 处理人按工单类型自动匹配，不需要编辑；原可点击修改逻辑注释保留 -->
              <!-- <EmployeeSelector @change="onSelectHandler" :value="[]">
                <a-button block style="text-align: left">
                  <span v-if="handler.name">{{ handler.name }}（可点击修改）</span>
                  <span v-else style="color: #999">按工单类型自动匹配，点击可修改</span>
                </a-button>
              </EmployeeSelector> -->
              <a-input :value="handler.name" :disabled="true" placeholder="按工单类型自动匹配" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <div class="footer">
        <a-space>
          <a-button v-if="mode === 'add'" @click="addDraft">存草稿</a-button>
          <a-button @click="cancel">取消</a-button>
          <a-button type="primary" :loading="loading" @click="submit">
            {{ submitText }}
          </a-button>
        </a-space>
      </div>
    </a-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Uploader from "@/components/uploader";
import watermark from "@/mixins/watermark";
import draft from "@/mixins/draft";
// 工单处理人改为只读（自动匹配），选择器组件不再使用
// import EmployeeSelector from "@/components/employee-selector";
import {
  addWorkOrder,
  updateWorkOrder,
  resubmitWorkOrder,
  fetchDetail,
  fetchConfigAll,
  fetchConfigMatch,
} from "@/api/oa/workOrder";

export default {
  name: "workOrderForm",
  mixins: [watermark, draft],
  components: { Uploader },
  // components: { EmployeeSelector },  // 处理人只读后不再使用

  props: {
    // add-新建，update-更新已终止，resubmit-重新提交已驳回
    mode: { type: String, default: "add" },
    // 来源工单ID（从已终止工单重新发起时复制内容）
    sourceId: { type: String, default: "" },
    // 目标工单ID（update/resubmit模式）
    orderId: { type: String, default: "" },
  },

  data() {
    return {
      loading: false,
      form: {
        title: "",
        priority: "common",
        workType: "",
        workModule: "",
        applyCategory: "",
        description: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        workType: [{ required: true, message: "请选择工单类型", trigger: "change" }],
        workModule: [{ required: true, message: "请选择涉及模块", trigger: "change" }],
        applyCategory: [{ required: true, message: "请选择申请分类", trigger: "change" }],
        description: [{ required: true, message: "请输入具体描述", trigger: "blur" }],
      },
      fileList: [],
      handler: {},
      configs: [],
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    applicantName() {
      return this.form.applicantName || this.user.userName || "";
    },
    deptName() {
      return this.form.deptName || (this.user.employeeVo && this.user.employeeVo.deptName) || "";
    },
    workTypeList() {
      return [...new Set(this.configs.map((c) => c.workType).filter(Boolean))];
    },
    workModuleList() {
      return [
        ...new Set(
          this.configs
            .filter((c) => c.workType === this.form.workType)
            .map((c) => c.workModule)
            .filter(Boolean)
        ),
      ];
    },
    applyCategoryList() {
      return [
        ...new Set(
          this.configs
            .filter(
              (c) =>
                c.workType === this.form.workType &&
                c.workModule === this.form.workModule
            )
            .map((c) => c.applyCategory)
            .filter(Boolean)
        ),
      ];
    },
    submitText() {
      if (this.mode === "update") return "保存";
      if (this.mode === "resubmit") return "重新提交";
      return "提交";
    },
  },

  mounted() {
    this.loadConfigs();
    if (this.mode === "update" || this.mode === "resubmit") {
      this.loadOrder(this.orderId);
    } else if (this.sourceId) {
      this.loadOrder(this.sourceId);
    }
  },

  methods: {
    loadConfigs() {
      fetchConfigAll().then((res) => {
        this.configs = Array.isArray(res) ? res : [];
      });
    },
    loadOrder(id) {
      if (!id) return;
      fetchDetail(id).then((res) => {
        const order = res || {};
        this.form = {
          title: order.title,
          priority: order.priority || "common",
          workType: order.workType,
          workModule: order.workModule,
          applyCategory: order.applyCategory,
          description: order.description,
        };
        // 申请人信息保留原单（从已终止工单重新发起时也沿用）
        if (order.applicantId) {
          this.form.applicantId = order.applicantId;
          this.form.applicantName = order.applicantName;
          this.form.deptId = order.deptId;
          this.form.deptName = order.deptName;
        }
        // 附件：详情接口返回文件列表（FileVo），补 uid/status 供 a-upload 回显；
        // 兼容旧数据（attachment 为URL-JSON格式）
        if (order.attachmentList && order.attachmentList.length > 0) {
          this.fileList = order.attachmentList.map((f, i) => ({
            uid: `file-${i}-${f.id || f.completePath}`,
            id: f.id || "",
            name: f.name,
            completePath: f.completePath || "",
            url: f.completePath || "",
            status: "done",
          }));
        } else if (order.attachment) {
          try {
            const arr = JSON.parse(order.attachment);
            if (Array.isArray(arr)) {
              this.fileList = arr.map((item, i) => {
                const base =
                  typeof item === "string"
                    ? { completePath: item, name: this.$getFileName(item) }
                    : item;
                return {
                  ...base,
                  // 旧URL数据无文件id，用路径充当id仅供Uploader展示（下载/删除），
                  // 提交时只提交真实文件id（见buildReq）
                  id: base.id || base.completePath,
                  uid: base.uid || `file-${i}-${base.completePath}`,
                  status: "done",
                };
              });
            }
          } catch (e) {
            this.fileList = [];
          }
        }
        if (order.handlerId) {
          this.handler = {
            id: order.handlerId,
            name: order.handlerName,
            deptId: order.handlerDeptId,
            deptName: order.handlerDeptName,
          };
        }
      });
    },
    // 工单类型卡片点击
    onWorkTypeChange(value) {
      if (this.form.workType === value) return;
      this.form.workType = value;
      this.form.workModule = "";
      this.form.applyCategory = "";
      this.matchHandler();
    },
    // 工单类型图标（矢量）
    getWorkTypeIcon(type) {
      const map = {
        功能开发: "code",
        数据处理: "database",
        数据业务处理: "database",
        权限申请: "key",
        设备报修: "tool",
        // server 图标在当前 @ant-design/icons 版本中不存在，改用最接近的 hdd
        其他: "hdd",
      };
      return map[type] || "appstore";
    },
    // 工单类型描述文案
    getWorkTypeDesc(type) {
      const map = {
        功能开发: "新增、修改瓴云系统功能，反馈系统故障",
        数据处理: "数据修改、补录、业务处理",
        权限申请: "账号申请、功能/数据权限",
        设备报修: "电脑、网络、打印机等",
        其他: "无法归入上述类型的事项",
      };
      return map[type] || "";
    },
    onWorkModuleChange() {
      this.form.applyCategory = "";
      this.matchHandler();
    },
    onApplyCategoryChange() {
      this.matchHandler();
    },
    // 按类型+模块+分类匹配处理人配置
    matchHandler() {
      const { workType, workModule, applyCategory } = this.form;
      if (!workType || !workModule) {
        this.handler = {};
        return;
      }
      fetchConfigMatch({ workType, workModule, applyCategory })
        .then((res) => {
          if (res && res.handlerDeptId) {
            // 配置支持多个处理人（逗号分隔）：全量保留，展示与提交均不截断；
            // 后端以 candidateUsers 多人候选下发，任一人可认领处理
            const handlerIds = (res.handlerIds || "")
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
              .join(",");
            const handlerNames = (res.handlerNames || "")
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
              .join(",");
            this.handler = {
              id: handlerIds,
              name: handlerNames,
              deptId: res.handlerDeptId,
              deptName: res.handlerDeptName,
            };
          } else {
            this.handler = {};
          }
        })
        .catch(() => {
          this.handler = {};
        });
    },
    // 手动选择处理人（处理人改为只读后不再使用）
    // onSelectHandler(arr) {
    //   const item = arr && arr.length > 0 ? arr[0] : null;
    //   if (item) {
    //     const org = item.employeeOrgVo || {};
    //     this.handler = {
    //       id: item.id,
    //       name: item.name,
    //       deptId: this.handler.deptId || org.id || "",
    //       deptName: this.handler.deptName || org.name || "",
    //     };
    //   }
    // },
    // Uploader上传/删除统一回调：直接更新文件列表（项为FileVo，含id/completePath/name）
    onFilesChange(arr) {
      this.fileList = arr || [];
    },
    // beforeUpload(file) {
    //   this.fileList = [
    //     ...this.fileList,
    //     {
    //       uid: file.uid,
    //       name: file.name,
    //       status: "uploading",
    //     },
    //   ];
    //   const data = new FormData();
    //   data.append("files", file);
    //   import("@/api/upload").then(({ uploadFile }) => {
    //     uploadFile(data)
    //       .then((res) => {
    //         if (Array.isArray(res) && res.length > 0) {
    //           const uploaded = res[0];
    //           const index = this.fileList.findIndex((f) => f.uid === file.uid);
    //           if (index > -1) {
    //             // 保留 uid（a-upload 渲染 key）并置为 done，否则上传成功后不回显
    //             // 附件只存文件id，提交时取id列表（FileVo.id）
    //             this.fileList.splice(index, 1, {
    //               uid: file.uid,
    //               status: "done",
    //               id: uploaded.id || "",
    //               completePath: uploaded.completePath || "",
    //               url: uploaded.completePath || "",
    //               name: file.name || uploaded.name,
    //             });
    //           }
    //         }
    //       })
    //       .catch(() => {
    //         this.fileList = this.fileList.filter((f) => f.uid !== file.uid);
    //       });
    //   });
    //   return false;
    // },
    // handleRemove(file) {
    //   this.fileList = this.fileList.filter((f) => f.uid !== file.uid && f.completePath !== file.completePath);
    // },
    // 组装请求数据
    buildReq() {
      return {
        title: this.form.title,
        priority: this.form.priority,
        workType: this.form.workType,
        workModule: this.form.workModule,
        applyCategory: this.form.applyCategory,
        description: this.form.description,
        // 附件只存文件id列表（逗号分割），后端返回时解析为文件列表；
        // 只提交真实文件id（旧URL数据的展示项无真实id，自动剔除）
        attachment: this.fileList
          .filter((f) => f.id)
          .map((f) => f.id)
          .join(","),
        applicantId: this.form.applicantId || this.user.uuid,
        applicantName: this.applicantName,
        deptId: this.form.deptId || (this.user.employeeVo && this.user.employeeVo.deptId) || "",
        deptName: this.deptName,
        handlerId: this.handler.id || "",
        handlerName: this.handler.name || "",
        handlerDeptId: this.handler.deptId || "",
        handlerDeptName: this.handler.deptName || "",
      };
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        if (this.mode === "add") {
          const req = { ...this.buildReq() };
          if (this.sourceId) {
            req.sourceId = this.sourceId;
          }
          addWorkOrder(req)
            .then(() => {
              this.loading = false;
              this.$message.success("工单提交成功");
              this.close();
            })
            .catch(() => {
              this.loading = false;
            });
        } else if (this.mode === "update") {
          updateWorkOrder({ ...this.buildReq(), id: this.orderId })
            .then(() => {
              this.loading = false;
              this.$message.success("工单更新成功");
              this.close();
            })
            .catch(() => {
              this.loading = false;
            });
        } else if (this.mode === "resubmit") {
          resubmitWorkOrder({ ...this.buildReq(), id: this.orderId })
            .then(() => {
              this.loading = false;
              this.$message.success("工单重新提交成功");
              this.close();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    close() {
      const path = "/oa/workOrder/mine";
      // 兼容标签页模式：关闭当前tab
      if (this.$close) {
        this.$close(this.$route.path);
      }
      this.$router.push(path).catch(() => {});
    },
    cancel() {
      if (this.$close) {
        this.$close(this.$route.path);
      }
      this.$router.push("/oa/workOrder/mine").catch(() => {});
    },

    // ---------------- 草稿 ----------------
    saveDraft() {
      if (!this.draftTitle) {
        this.$message.warning("请输入草稿标题");
        return;
      }
      this.updateDraft({
        id: this.draftId ? this.draftId : undefined,
        title: this.draftTitle + " " + moment().format("YYYY-MM-DD"),
        type: this.draftType,
        content: JSON.stringify({
          form: this.form,
          fileList: this.fileList,
          handler: this.handler,
        }),
      }).then(() => {
        this.$message.success("草稿已保存");
        this.cancelDraft();
      });
    },
    onSelectDraft(draft) {
      if (draft.id && draft.content) {
        this.draftId = draft.id;
        this.draftTitle =
          typeof draft.title === "string" ? draft.title.split(" ")[0] : "";
        const res = JSON.parse(draft.content);
        if (res.form) {
          this.form = { ...this.form, ...res.form };
        }
        if (Array.isArray(res.fileList)) {
          this.fileList = res.fileList;
        }
        if (res.handler) {
          this.handler = res.handler;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.section-title {
  font-size: 15px;
  font-weight: bold;
  border-left: 3px solid #1890ff;
  padding-left: 8px;
  margin: 16px 0 16px;
}

.type-cards {
  display: flex;
  flex-wrap: wrap;

  .type-card {
    min-width: 150px;
    padding: 12px 16px;
    margin: 0 12px 12px 0;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;

    .type-icon {
      font-size: 20px;
      margin-bottom: 4px;
    }

    .type-name {
      font-weight: bold;
      font-size: 14px;
    }

    .type-desc {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }

    &:hover {
      border-color: #1890ff;
    }

    &.active {
      border-color: #1890ff;
      background-color: #e6f7ff;
      color: #1890ff;

      .type-desc {
        color: #1890ff;
        opacity: 0.65;
      }
    }
  }
}

.footer {
  text-align: center;
  padding: 16px 0 8px;
  border-top: 1px solid #e8e8e8;
}
</style>
